import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Wallet from '../../../../components/wallet';
import { CryptodraftContext } from '../../../../contexts/card/cryptodraft/context';
import { currencies } from '../../../../utilities/constants';
import { cryptodraftScreens } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';

const Wallets = () => {
  const { t: translate } = useTranslation();

  const { state, openScreen, updateSelectedSettlementWallet } = useContext(CryptodraftContext);

  const allowedWallets = state?.allowedSettlementWallets;
  const prevScreen = state?.screenOptions?.prevScreen;

  const [searchValue, setSearchValue] = useState('');
  const [renderedWallets, setRenderedWallets] = useState(allowedWallets);

  const handleSearchInput = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (searchValue) {
      const filterWallets = allowedWallets.filter(
        (wallet) =>
          wallet.coin.toLowerCase().includes(searchValue.toLowerCase()) ||
          currencies[wallet.coin.toUpperCase()]?.fullName
            .toUpperCase()
            .search(searchValue.toUpperCase()) >= 0
      );
      setRenderedWallets(filterWallets);
    } else {
      setRenderedWallets(allowedWallets);
    }
  }, [searchValue, allowedWallets]);

  return (
    <MainBodyLayout
      withBack
      withInfoIcon
      onPrevClick={() => openScreen(prevScreen)}
      title={translate('select_source_of_payment_title')}>
      <div className="mt-4 pt-1">
        <div className="rounded bg-lighter p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative">
          <input
            type="text"
            value={searchValue}
            onChange={(e) => handleSearchInput(e)}
            className="form-control border-1 border-transparent rounded bg-light shadow-none w-100 ps-5 d-flex box-input"
            placeholder={translate('select_wallet_input_placeholder')}
          />
          <i className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
          <i
            onClick={() => {
              setSearchValue('');
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
            label="close"
            hidden={searchValue === '' || searchValue === null || searchValue === undefined}
            className="icon icon-close-other text-white position-absolute top-50 end-0 translate-middle-y pe-3"
          />
        </div>
      </div>
      <div>
        {renderedWallets.map((item) => (
          <Wallet
            key={item.id}
            data={item}
            openScreen={(prev) => {
              if (prev === cryptodraftScreens.SETTLE) {
                openScreen(prev, {
                  confirmOpened: true,
                });
              } else {
                openScreen(prev);
              }
            }}
            chooseWallet={updateSelectedSettlementWallet}
            mainScreen={prevScreen}
            className="bg-lighter"
          />
        ))}
      </div>
    </MainBodyLayout>
  );
};

export default Wallets;
